<template>
  <div class="hello">
    <b-container fluid>
      <b-alert show>User Add/Edit</b-alert>
      <b-form @submit="onSubmit" @reset="onReset" v-if="show">
        <b-row>
          <b-col cols="2" class="text-center">
            <h5>Profile</h5>
            <br>
            <image-uploader
              :preview="true"
              :className="['fileinput', { 'fileinput--loaded': hasImage }]"
              capture="environment"
              :debug="1"
              doNotResize="gif"
              :autoRotate="true"
              outputFormat="verbose"
              @input="setImage"
            >
              <label for="fileInput" slot="upload-label">
                <figure>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                  >
                    <path
                      class="path1"
                      d="M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z"
                    ></path>
                  </svg>
                </figure>
                <span class="upload-caption">
                  {{
                  hasImage ? "Replace" : "Click to upload"
                  }}
                </span>
              </label>
            </image-uploader>
            <!-- <img alt="Vue logo" src="../assets/icons8-administrator-male-104.png">
            <br>
            <a style="font-size: small;" href>Change Photo</a>-->
          </b-col>
          <b-col>
            <b-row>
              <b-col>
                <b-form-group id="input-group-2" label="First Name:" label-for="input-2">
                  <b-form-input
                    id="input-2"
                    v-model="form.firstName"
                    placeholder="Enter First Name"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="input-group-3" label="Last Name:" label-for="input-3">
                  <b-form-input id="input-3" v-model="form.lastName" placeholder="Enter Last Name"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="id == ''">
              <b-col>
                <b-form-group id="input-group-10" label="Password:" label-for="input-10">
                  <b-form-input
                    id="input-10"
                    type="password"
                    v-model="form.password"
                    placeholder="Enter Password"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="input-group-11" label="Confirm Password:" label-for="input-11">
                  <b-form-input
                    id="input-11"
                    type="password"
                    v-model="form.confirmPassword"
                    placeholder="Confirm Password"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group id="input-group-1" label="Email address:" label-for="input-1">
                  <b-form-input
                    id="input-1"
                    v-model="form.email"
                    type="email"
                    required
                    placeholder="Enter email"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group id="input-group-4" label="Phone:" label-for="input-4">
                  <b-form-input id="input-4" v-model="form.phoneNumber" placeholder="Phone"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="input-group-5" label="Mobile:" label-for="input-5">
                  <b-form-input id="input-5" v-model="form.mobile" placeholder="Mobile"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group id="input-group-6" label="Address:" label-for="input-6">
                  <b-form-input id="input-6" v-model="form.address" placeholder="Address"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="5">
                <b-form-group id="input-group-7" label="Suite/Apt:" label-for="input-7">
                  <b-form-input id="input-7" v-model="form.suiteApt" placeholder="Suite/Apt"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-form-group id="input-group-8" label="City:" label-for="input-8">
                  <b-form-input id="input-8" v-model="form.city" placeholder="City"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <label for="input-state">State</label>
                <b-form-select id="input-state" v-model="form.state" :options="stateOptions"></b-form-select>
                <!-- <select id="input-state">
                  <option value="FL">FL</option>
                </select>-->
              </b-col>
              <b-col>
                <b-form-group id="input-group-9" label="Zip:" label-for="input-9">
                  <b-form-input id="input-8" v-model="form.zip" placeholder="Zip"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="4">
            <label>Roles:</label>
            <multiselect
              :multiple="true"
              track-by="name"
              :close-on-select="false"
              :clear-on-select="false"
              label="name"
              v-model="form.roles"
              :options="roles"
            ></multiselect>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div>
              <b-button type="submit" variant="primary" style="margin: 5px;">Save</b-button>
              <b-button style="margin: 5px;" @click="cancel">Cancel</b-button>
              <b-button style="margin: 10px;">Reset Password</b-button>
            </div>
          </b-col>
        </b-row>
      </b-form>
      <!-- <pre><code>{{ form  }}</code></pre> -->
    </b-container>
  </div>
</template>

<script>
import ajax from '@/resources/myApi.js';
import Multiselect from 'vue-multiselect';

export default {
  name: 'edit-user',
  components: { Multiselect },
  data() {
    return {
      form: {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        active: true,
        mobile: '',
        address: '',
        suiteApt: '',
        city: '',
        state: 'FL',
        zip: '',
        roles: []
      },
      stateOptions: [{ value: 'FL', text: 'FL' }],
      errors: [],
      roles: [{ name: 'Administrator' }, { name: 'Client' }],
      show: true,
      hasImage: false,
      id: '',
      loader: null
    };
  },
  methods: {
    cancel() {
      this.$router.push({ name: 'UserList' });
    },
    setImage: function(file) {
      this.hasImage = true;
      this.image = file;
    },
    onSubmit(evt) {
      
      evt.preventDefault();
      var data = Object.assign({}, this.form);
      data.roles = [];
      this.form.roles.map(function(key) {
        data.roles.push(key.name);
      });
      this.loader = this.$loading.show();

      if (this.id != '') {
        ajax.put('api/user/' + this.id, {
          name: 'updateUser',
          body: data
        }).then(response => {
          console.log(response);
          this.loader.hide();
          this.$snotify.success('User saved', 'User');
          this.$router.push({ name: 'UserList' });
        });
      } else {
        ajax.post('api/user/create',
          {
            name: 'newUser',
            body: data
          }).then(response => {
          console.log(response);
          this.loader.hide();
          this.$snotify.success('User created', 'User');
          this.$router.push({ name: 'UserList' });
        });
      }
    },
    handleRoles() {
      //console.log(rol);
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = '';
      this.form.firstName = '';
      this.form.lastName = '';
      this.form.mobile = '';
      this.form.address = '';
      this.form.active = true;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  },
  created() {
    this.id = this.$route.params.id;

    if (this.id) {
      ajax
        .get('api/user/' + this.id, {
          transformResponse: [
            data => {
              let resp;
              try {
                resp = JSON.parse(data);
                var roles = [];
                resp.roles.map(function(key) {
                  console.log(key);
                  roles.push({ name: key });
                });
                resp.roles = roles;
              } catch (error) {
                throw Error(
                  `[requestClient] Error parsing response JSON data - ${JSON.stringify(
                    error
                  )}`
                );
              }

              return resp;
            }
          ]
        })
        .then(response => {
          this.form = response.data;
          //this.loader.hide();
        })
        .catch(e => this.errors.push(e));
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
<style>
#fileInput {
  display: none;
}
.img-preview {
  width: 200px;
}
</style>
